/**
 * O "Instalar Benvox" do navegador só onde ele faz sentido: no painel.
 *
 * As páginas que um workspace entrega ao SEU cliente — site, formulário, chat,
 * documento, portal — são da marca dele. Oferecer ali a instalação do painel da
 * Benvox seria convidar o cliente do cliente a instalar uma tela de login que não
 * é para ele. O link do manifesto vem no `index.html`; aqui ele sai e volta
 * conforme a rota, e o Chrome reavalia a instalação quando o link muda.
 *
 * Pelo prefixo do caminho e não pelo `meta.public`: o login também é público, e
 * é justamente onde o dono instala. `/p/` já está na lista para o portal.
 */
const TENANT_PUBLIC = /^\/(s|f|embed|c|d|p)\//;

export function isTenantPublicPath(path: string): boolean {
	return TENANT_PUBLIC.test(path.endsWith("/") ? path : `${path}/`);
}

let link: HTMLLinkElement | null = null;

export function syncManifestLink(path: string): void {
	link ??= document.querySelector<HTMLLinkElement>("link#app-manifest");
	if (!link) return;
	if (isTenantPublicPath(path)) link.remove();
	else if (!link.isConnected) document.head.append(link);
}
